<template>
    <b-button
        variant="bq-green"
        class="h-100 w-100 iat-choice-button d-flex justify-content-center align-items-center"
        @click="handleClick"
    >
        <div class="iat-choice-button__identifier">
            <slot />
        </div>
    </b-button>
</template>
<script>
export default {
    name: 'iatChoiceButton',
    props: {
        value: {
            type: String
        }
    },
    methods: {
        handleClick() {
            this.$emit('click', this.value)
        }
    }
}
</script>
<style lang="scss">
.iat-choice-button {
    font-weight: bold;
    font-size: 1.1em;
    border-radius: 12px;
}
</style>